export interface RouteConfig {
  Android?: string;
  iOS?: string;
  Desktop?: string;
  default?: string;
  fallback?: string;
  androidIntent?: boolean;
}

export interface RedirectConfig {
  [path: string]: RouteConfig;
}

export const redirectConfig: RedirectConfig = {
  "/invoices/create/redirect": {
      Android: "intent://add-invoice#Intent;scheme=esemie;package=com.esemie;end",
    iOS: "https://app.esemie.io/invoices/createFreeform",
    Desktop: "https://app.esemie.io/invoices/createFreeform",
    fallback: "https://play.google.com/store/apps/details?id=com.esemie",
    default: "https://app.esemie.io/invoices/createFreeform",
    androidIntent: true
  },
  "/subscription/redirect": {
      Android: "intent://subscription-stat#Intent;scheme=esemie;package=com.esemie;end",
      iOS: "https://app.esemie.io/settings?tab=subscription",
      Desktop: "https://app.esemie.io/settings?tab=subscription",
      fallback: "https://play.google.com/store/apps/details?id=com.esemie",
      default: "https://app.esemie.io/settings?tab=subscription",
      androidIntent: true
    },
    "/inventories/:id/restock/redirect": {
      Android: "intent://restock-inventory#Intent;scheme=esemie;package=com.esemie;S.id={id};end",
      iOS: "https://app.esemie.io/inventories/{id}/restock",
      Desktop: "https://app.esemie.io/inventories/{id}/restock",
      fallback: "https://play.google.com/store/apps/details?id=com.esemie",
      default: "https://app.esemie.io/inventories/{id}/restock",
      androidIntent: true
    }
};